import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {TurnsService} from '../../services/turns-services/turns-service/turns.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, Validators} from '@angular/forms';

@Component({
  selector: 'app-add-notes-dialog',
  templateUrl: './add-notes-dialog.component.html',
  styleUrls: ['./add-notes-dialog.component.scss']
})
export class AddNotesDialogComponent implements OnInit, OnDestroy {

  public notes: any;
  public turnInternalId: any;

  form = this.formBuilder.group({
    notes: ['', Validators.required],
  });

  constructor(
    private turnsService: TurnsService,
    public formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<AddNotesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.notes = this.data.notes;
    this.turnInternalId = this.data.turnInternalId;
  }

  ngOnInit(): void {
    // 1. SOLUCIÓN AL PROBLEMA DEL VALOR: Inicializamos el formulario con los datos recibidos.
    if (this.notes) {
      this.form.patchValue({ notes: this.notes });
    }
  }

  addTurnInformation() {
    if (this.form.invalid) {
      return;
    }

    const body = { turnInternalId: this.turnInternalId, info: this.form.controls.notes.value };
    this.turnsService.addTurnInformation(body).subscribe({
      next: () => {
        this.dialogRef.close(true);
      },
      error: (error: any) => {
        // switch (error['error']['data']['error']) {
        //   case "API:RENT-CHECKOUT-0002":
        //     this.feedbackError = "NOT_REQUIRED_DEVICES"
        //     break;
        // }
      }
    });
  }

  cancel() {
    this.dialogRef.close(false);
  }

  ngOnDestroy(): void {
  }

}
